import React from 'react';
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import Rating from "react-rating";

const Ratings = ({ rating }) => {
  return (
    <div>
      <Rating readonly initialRating={rating} emptySymbol={<AiOutlineStar  color='orange' size={'30px'}/>} fullSymbol={<AiFillStar  color='orange' size={'30px'}/>} />
    </div>
  );
};

export default Ratings;